// extracted by mini-css-extract-plugin
module.exports = {"container":"onlineConsultant_container__3ESV9","detailModal":"onlineConsultant_detailModal__3qFtp"};